import { Link as GatsbyLink, GatsbyLinkProps, graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useMemo, useState } from 'react';

import { GatsbyImageWithFallback } from '@ajc/lib-gatsby';
import { LinkGroupProps, LinkList, StrapiContentStatus } from '@ajc/lib-mui';
// import styled from '@emotion/styled';
import { Close, HomeOutlined, Menu } from '@mui/icons-material';


const requiredPublishType: StrapiContentStatus = process.env.GATSBY_STRAPI_CONTENT_STATUS

import {
  AppBar, Box,
  Button,
  Container, Divider,
  IconButton,
  Stack, SxProps, Theme, Toolbar,
  Typography,
  useTheme
} from '@mui/material';

const desktopNavBarBottomBorderWidth = '7px'
const desktopNavBarBottomBorderColor = "#F5F5F5"

export const mobileLinkStyle = (muiTheme: Theme) => ({
  display: "block",
  color: "#1A1A1A",
  zIndex: 1,
  fontSize: muiTheme.typography.h3.fontSize,
  paddingTop: muiTheme.spacing(1),
  paddingBottom: muiTheme.spacing(1),
  paddingLeft: muiTheme.spacing(4),
  paddingRight: muiTheme.spacing(4),
  marginBottom: muiTheme.spacing(1),
})

export const mobileAppFloatingMenuStyle = (muiTheme: Theme) => ({
  color: "#1A1A1A",
  zIndex: 999,
  // fontSize: muiTheme.typography.h3.fontSize,
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  pt: 12,
  pl: 1,
  pr: 1,
  position: "absolute",
  background: muiTheme.palette.brandCream.main,
})

const desktopNavItemBorderStyles = (theme: Theme, color: string) => ({
  borderStyle: 'solid',
  borderColor: color,
  borderWidth: '0',
  borderBottomWidth: desktopNavBarBottomBorderWidth,
})
const navLinkActiveStyles = (theme: Theme) => ({
  color: theme.palette.primary.main,
  ...desktopNavItemBorderStyles(theme, desktopNavBarBottomBorderColor)
})

const navLinkStyles = (theme: Theme): SxProps => ({
  color: 'inherit',
  fontWeight: 'normal',
  fontSize: '1rem',
  height: '48px',
  textDecoration: 'none',
  ...desktopNavItemBorderStyles(theme, 'transparent')
})

export const desktopAppBarStyle = (theme: Theme) => ({
  background: '#F3F3F3',
  color: theme.palette.text.primary,
  // pt: 2,
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // height: '48px',
  boxShadow: 'none',
  // boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
  ...desktopNavItemBorderStyles(theme, '#5F2116')
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const desktopTopAppBarStyle = (theme: Theme) => ({
  background: theme.palette.secondary.dark,
  color: theme.palette.secondary.contrastText,
  pt: theme.spacing(0.5),
  pb: theme.spacing(0.5),
  pr: theme.spacing(0),
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const desktopMiddleAppBarStyle = (theme: Theme): SxProps => ({
  background: theme.palette.brandCream.main,
  color: theme.palette.brandCream.contrastText,
  pt: theme.spacing(2),
  pb: theme.spacing(2),
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const mobileAppBarStyle = (theme): SxProps => ({
  // background: "transparent",
  // pt: 1,
  // pr: 1,
  // pl: 0,
  background: theme.palette.brandCream.main,
  color: theme.palette.brandCream.contrastText,
  display: {
    xs: "inherit",
    sm: "inherit",
    md: "none",
    lg: "none",
    xl: "none",
  },
  borderBottom: '4px solid #5F2116'
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const baseLogoHeight = 48
export const baseLogoWidth = 230

export default function Header() {
  const headerDataQuery: Queries.HeaderComponentQuery = useStaticQuery(graphql`
    query HeaderComponent {
      strapiWebsiteInfo {
        companyName: CompanyName
      }
      strapiHeader {
        logo: Logo {          
          name
          url
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, height: 80, quality: 100)
            }
          }
        }
        links: Links {
          url: URL
          label: Label
          hidden: Hidden
          links: Links {
            label: Label
            url: URL
            hidden: Hidden
            links: Links {
              label: Label
              url: URL
              hidden: Hidden
            }
          }
        }
      }
    }
  `)

  // const NotPrintable = useMemo(() => styled('div')(notPrintable), []);

  const headerProps = useMemo(() => {
    return { ...headerDataQuery }
  }, [])

  return (
    // <NotPrintable>
    // <MuiThemeProvider theme={appTheme}>
    <>
      <MobileHeader {...headerProps} />

      <DesktopHeader {...headerProps} /></>
    // </MuiThemeProvider>
    // </NotPrintable>
  )
}
type HeaderComponentProps = Queries.HeaderComponentQuery

const TopAppBar = ({ sx, theme }: { sx: SxProps, theme: Theme }) => {
  return <AppBar position="static" elevation={0} sx={{
    ...sx, background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderBottom: '0',
    py: 0.5,
  }}>
    <Container>
      <Stack direction='row' justifyContent='center' alignItems='center' sx={{ width: '100%' }}>
        <Typography variant="body2" sx={{ textAlign: { xs: 'center', sm: 'center', md: 'inherit' } }}>Aboriginal and Torres Strait Islander viewers are advised that this website contains the names and images of people who have passed</Typography>
        {/* <Stack direction={'row'} gap={1}>
              <Phone htmlColor={theme.palette.secondary.light} />
              <Link forceLink variant='text' label={"Contact information"} relativeLinkComponent={GatsbyLink} url="/contact" />
            </Stack> */}
      </Stack>
    </Container>
  </AppBar>
}

const DesktopHeader = ({ strapiHeader, strapiWebsiteInfo }: HeaderComponentProps) => {
  const theme = useTheme();
  const appBarStyle = desktopAppBarStyle(theme)
  const middleBarStyle = desktopMiddleAppBarStyle(theme)
  const navLinkActiveStyle = navLinkActiveStyles(theme)
  const logo = strapiHeader?.logo;
  const navLinkStyle = navLinkStyles(theme)

  // const navLinkSxActive = useMemo(() => ({ color: '#022A50' }), []);

  const iconMapping = useMemo(() => {
    return { 'Home': <HomeOutlined sx={{ fontWeight: 'normal', color: '#729E4F' }} /> }
  }, [])

  return (
    <>
      <TopAppBar sx={appBarStyle} theme={theme} />
      <AppBar position="static" elevation={0} sx={{ ...middleBarStyle }}>
        <Container>
          <Toolbar disableGutters>
            <Stack
              sx={{ width: "100%" }}
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                direction={"row"}
                divider={<Divider orientation="vertical" sx={{ borderColor: theme.palette.secondary.dark, borderWidth: 1.2, mt: 4, mb: 4 }} flexItem />}
                justifyContent="flex-start"
                gap={6}
                alignItems="center"
              >
                <GatsbyLink to="/">
                  <Box sx={{ display: "none" }}>Home</Box>
                  {logo && <Box pt={1} pb={1}><GatsbyImageWithFallback url={logo.url} image={logo.localFile?.childImageSharp?.gatsbyImageData} alt={logo.name} /></Box>}
                </GatsbyLink>
              </Stack>

              <Button href="https://google.com.au" color="primary" variant="contained">Quick exit</Button>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <AppBar position="static" elevation={0} sx={{ ...appBarStyle }}>
        <Container>
          <Toolbar disableGutters sx={{ minHeight: '0px!important' }}>
            <Stack
              sx={{ width: "100%" }}
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <nav>
                <Stack
                  direction={"column"}
                  justifyContent="space-evenly"
                  alignItems="center"
                >
                  {strapiHeader?.links && (
                    <LinkList
                      LinkGroupHeaderLabelToIconMapping={iconMapping}
                      links={strapiHeader?.links as LinkGroupProps[]}
                      requiredPublishType={requiredPublishType}
                      LinkGroupItemsStackProps={{ gap: 1 }}
                      LinkGroupItemsTypographyProps={{ sx: { fontSize: '1rem!important', color: theme.palette.text.primary, pl: 0.5 } }}
                      LinkGroupHeaderLinkProps={{ sx: { ...navLinkStyle, paddingTop: '12px' } }}
                      LinkGroupHeaderTypographyProps={{ sx: navLinkStyle }}
                      withDropdown
                      // ButtonProps={{ sx: { cursor: 'pointer' } }}
                      StackProps={{ direction: "row" }}
                      // StackProps={{ direction: "row", gap: { md: 1, lg: 2 } }}
                      relativeLinkComponent={GatsbyLink}
                      LinkProps={{ activeStyle: navLinkActiveStyle, style: { textDecoration: 'none' } } as GatsbyLinkProps<any> as any}
                    />
                  )}
                </Stack>
              </nav>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
    </>

  )
}

const MobileHeader = ({ strapiHeader }: HeaderComponentProps) => {
  const theme = useTheme()

  const appBarStyle = mobileAppBarStyle(theme)

  const openMenuStyle = mobileAppFloatingMenuStyle(theme)
  // const mobileLinkStyling = mobileLinkStyle(theme)
  const [isOpen, setOpen] = useState(false)
  const logo = strapiHeader?.logo;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [isOpen])

  return (
    <>
      {!isOpen && <TopAppBar sx={appBarStyle} theme={theme} />}
      <AppBar position="static" elevation={0} sx={appBarStyle}>
        <Toolbar disableGutters sx={{ zIndex: 9999 }}>
          <Container sx={{ width: "100%" }}>
            <Stack
              sx={{ width: "100%", py: 1.5 }}
              spacing={6}
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <GatsbyLink onClick={() => setOpen(false)} to="/">
                <Box sx={{ display: "none" }}>Home</Box>
                {logo && <GatsbyImageWithFallback url={logo.url} image={logo.localFile?.childImageSharp?.gatsbyImageData} alt={logo.name} />}
              </GatsbyLink>

              <Box sx={{ width: '85px', height: '31px', visibility: isOpen ? 'hidden' : undefined }}><Button href="https://google.com.au" size="small" sx={{ m: 0, py: '4px', width: '100%', whiteSpace: 'nowrap' }} color={"primary"} variant="contained">Quick exit</Button></Box>

            </Stack>
          </Container>
        </Toolbar>
        <Box sx={{ backgroundColor: '#f3f3f3', width: '100%' }}>
          <Container>
            {!isOpen && (
              <Stack
                direction="row"
                alignItems="center"
                width={"100%"}
                justifyContent={"flex-end"}
              >
                <Box>
                  <Button
                    title="Toggle menu"
                    sx={{ color: "#414141", px: 0, textDecoration: 'none!important' }}
                    onClick={() => setOpen(true)}
                    startIcon={<Menu />}
                  >
                    Main Menu
                  </Button>
                </Box>
              </Stack>
            )}
          </Container>
        </Box>
      </AppBar>
      {isOpen && (
        <Box sx={openMenuStyle}>
          <nav style={{ height: '100%' }}>
            <Box sx={{ overflowY: 'auto', height: '100%', pb: 4 }}>
              <Stack direction={'column'} sx={{ width: '100%' }} alignItems={'stretch'}>
                {strapiHeader?.links && (
                  <LinkList requiredPublishType={requiredPublishType} ButtonProps={{ sx: { textDecoration: 'none' } }} LinkProps={{ underline: 'none' }} onClick={() => setOpen(false)} links={strapiHeader?.links as LinkGroupProps[]} LinkGroupItemsTypographyProps={{ sx: { textDecoration: 'none' } }} LinkGroupHeaderLinkProps={{ underline: 'none', sx: { textDecoration: 'none' } }} alignLeft relativeLinkComponent={GatsbyLink} />
                )}
              </Stack>
            </Box>
          </nav>
        </Box>
      )}
      {isOpen && <Box sx={{ position: 'absolute', zIndex: 99999, top: '20px', right: '20px' }}><Box><IconButton
        title="Toggle menu"
        sx={{ m: 0 }}
        size='large'
        onClick={() => setOpen(!isOpen)}
      >
        <Close sx={{ color: "#1A1A1A" }} />
      </IconButton></Box></Box>
      }
    </>
  )
}
